import { IndividualStep1Personal } from "./individual/IndividualStep1Personal";
import { IndividualStep2Residency } from "./individual/IndividualStep2Residency";
import { IndividualStep3Health } from "./individual/IndividualStep3Health";
import { IndividualStep4Employer } from "./individual/IndividualStep4Employer";
import { IndividualStep5OthersAndDocuments } from "./individual/IndividualStep5OthersAndDocuments";
import { useWizard } from "../context/WizardContext";

const STEPS = [
  IndividualStep1Personal,
  IndividualStep2Residency,
  IndividualStep3Health,
  IndividualStep4Employer,
  IndividualStep5OthersAndDocuments,
];

export function IndividualWizardSteps() {
  const { currentStepIndex } = useWizard();
  const Step = STEPS[currentStepIndex];
  if (!Step) return null;
  return <Step />;
}
